import React from 'react';
import styled from 'styled-components';
import LandingPageHeader from '../../components/LandingPageHeader/LandingPageHeader';
import ErrorImg from '../../resources/images/error.png';
import { setPageErrorData } from '../../DumbleData';

// Simple error page when the fair falls outside the des
const Error = () => {
	setPageErrorData(true);

	return (
		<>
			<LandingPageHeader></LandingPageHeader>
			<StyledContainer>
				<StyledImage src={ErrorImg} alt=""></StyledImage>
				<StyledHeading>Unfortunately, something went wrong.</StyledHeading>
			</StyledContainer>
		</>
	);
};

const StyledContainer = styled.div`
	margin-top: 122px;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 280px;
	margin-left: auto;
	margin-right: auto;
`;

const StyledImage = styled.img`
	margin-bottom: 24px;
`;

const StyledHeading = styled.h1`
	margin-top: 0;
	font-size: 28px;
	font-weight: 300;
	line-height: 32px;
	text-align: center;
	margin-bottom: 27px;
`;

export default Error;
